import React from 'react';
import { Container, Col, Row, Image } from 'react-bootstrap';
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import '../../../Assets/css/mjstatic.css';
import Button from '@mui/material/Button';

import { Helmet } from 'react-helmet';
import aboutimg from '../../../Assets/images/static/demo/img-about2.jpg';
import { useSelector } from 'react-redux';
import Ani38 from '../../../Assets/images/DFL/ani_38.png';
import Ani38Mobile from '../../../Assets/images/DFL/ani_38_mobile.png';
import CertiImg1 from '../../../Assets/images/DFL/certi1.png';
import CertiImg2 from '../../../Assets/images/DFL/certi2.png';
import CertiImg3 from '../../../Assets/images/DFL/certi3.png';
import giaImg from '../../../Assets/images/DFL/gia.png';
import igiImg from '../../../Assets/images/DFL/igi.png';
import hrdImg from '../../../Assets/images/DFL/hrd.png';
import GoogleReview from '../../../Assets/images/DFL/google-about.png';

const OurStory = () => {
  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails?.title}</title>
        <meta name="description" content={metaDetails?.description}></meta>
        <meta name="keywords" content={metaDetails?.keywords}></meta>
      </Helmet>

      <div className="rcs_ringsetting_section ">
        <div className="rcs_customDesgin_banner dfl_about_banner">{/* <h2>  Here's the story of a local 3rd generation family owned <br />and operated business  </h2> */}</div>
        <Container>
          <Row className="m-auto w-100">
            <Col sm={12} md={12} lg={12} className="p-0">
              <div className="rcs_story_content">
                <h1 className="text-center">
                  About Us <br /> Here Is The Story Of 3rd Generation Family Business
                </h1>
                <p>Diamonds for less is not just a business, it is a story of passion, hard work, family and dedication. From humble beginnings and small retail stores in the early 80’s as separate young entrepreneurs to then becoming business partners and establishing one of the largest diamond wholesalers in Canada, Kevin Nahabedian and Serko Mikaelian have created a legacy that will continue for generations to come. Their unique business model, expertise, and commitment to excellence have made them a trusted source for diamonds and diamond jewellery.</p>
                <p>In the early 90s, Serko and Kevin joined forces and entered the diamond wholesale business. Their unique skills and experiences allowed them to revolutionize the jewellery industry with their innovative business model. They sourced rough diamonds globally, cut and polished them in the world’s largest cutting centers, built a jewellery factory and implemented a vertical production of diamonds and diamond jewellery.</p>
                <p>While becoming one of the largest diamond distributors, they never lose touch with their roots in retail and continue to serve their loyal clients, maintaining the same excellent customer service, honest advice clients were accustomed to for years. With their volume purchasing power, they are now also able to offer their clients the lowest wholesale prices possible</p>
                <p>Serko and Kevin have not only been successful business owners but also great family leaders and mentors. With the addition of the next generation they have been able to lead, teach and instil their values, work ethic and experiences to their children and family members.</p>
                <p>Over the past five decades, Diamonds For Less has overcome numerous challenges and changes in the industry, economy and society but has prevailed thanks to their vision, adaptability and years of experience. With over a century of combined experience, focus and specialization in diamonds they can identify the latest and up to date technologies, manufacturing techniques and trend shifts early on.</p>
              </div>
            </Col>
          </Row>
        </Container>

        <Container>
          <div className="dfl_ani_img_section">
            <img src={Ani38} className="img-fluid dfl_ani_img_desktop" />
            <img src={Ani38Mobile} alt="Anniversry Image" className="img-fluid dfl_ani_img_mobile" />
          </div>
        </Container>

        <Container className="rcs_story_content mt-5 mb-5">
          <Row className="m-auto w-100">
            <Col sm={12} md={12} xs={12} className="p-0 dfl_team_img">
              <h2 className="text-center">WHY CHOOSE US</h2>
              <div className="rcs_our_story_img_main">
                <Image src={aboutimg} alt="about us image" className="img-fluid"></Image>
              </div>
            </Col>
            <Col sm={12} md={12} xs={12} className="p-0 mt-sm-3 mt-md-3 mt-lg-5">
              <p>
                Today, DFL is still family owned and operated, continuing the tradition of excellence and innovation in the diamond and jewellery industry. The company remain’s committed to providing the{' '}
                <NavLink to="/wholesale-diamonds-for-sale-toronto" className="text-dark text-decoration-none">
                  <strong>best quality diamonds,</strong>
                </NavLink>
                <NavLink to="/engagement-rings-toronto" className="text-dark text-decoration-none">
                  <strong> engagement rings</strong>
                </NavLink>{' '}
                and{' '}
                <NavLink to="/jewellery" className="text-dark text-decoration-none">
                  <strong>diamond jewellery</strong>
                </NavLink>
                at the lowest wholesale prices, along with excellent customer service and expert advice.
              </p>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className="dfl_over_certified">
            <h3 className="text-center">Our Certificates</h3>
          </Row>
          <Row>
            <Col sm={12} md={4} lg={4}>
              <div className="dfl_abotus_certi_imgbox">
                <Image src={CertiImg1} alt="Certificate Image" className="img-fluid" />
              </div>
            </Col>
            <Col sm={12} md={4} lg={4}>
              <div className="dfl_abotus_certi_imgbox">
                <Image src={CertiImg2} alt="Certificate Image" className="img-fluid" />
              </div>
            </Col>
            <Col sm={12} md={4} lg={4}>
              <div className="dfl_abotus_certi_imgbox">
                <Image src={CertiImg3} alt="Certificate Image" className="img-fluid" />
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <div className="dfl_aboutus_logo_box">
                <Image src={giaImg} alt="Certificate Image" className="img-fluid" />
                <Image src={igiImg} alt="Certificate Image" className="img-fluid" />
                <Image src={hrdImg} alt="Certificate Image" className="img-fluid" />
                <Image src={GoogleReview} alt="Certificate Image" className="img-fluid mr-0" onClick={() => window.open('https://www.google.com/search?gs_ssp=eJzj4tZP1zcsSclONrTINmC0UjGosLBMMUlOMjZJNDUwMDO0MLcyqDBPMTc3TTRLNDUzMUwzSvESTMlMzM3PSylWSMsvUshJLS4GAK4qFIo&q=diamonds+for+less&rlz=1C5CHFA_enIN947IN947&oq=diamonds+for+less&aqs=chrome.1.0i355i512j46i175i199i512j0i512l4j0i22i30j69i61.4551j0j7&sourceid=chrome&ie=UTF-8#lrd=0x89d4cb34a5006187:0x7d775a6a5641f2d,1', '_blank')} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default OurStory;
